/* eslint-disable no-param-reassign  */

import {
    createAsyncThunk,
    configureStore,
    createSlice,
} from '@reduxjs/toolkit';
import DashboardService from './DashboardService';

const dashboardService = new DashboardService();

const DashboardState = {
    apiResponse: '',
    redirectTo: false,
    data: [],
    listResponse: [],
    currentPage: 1,
    pageLimit: 20,
    totalRecords: 0,
    pagedata: [],
    formOpened: false,
    filterData: {},
    redirect: false,
    isRetrying: false,
    isReprocess: false,
    isUpdating: false,
    gettingData: false,
    sortColumn: { columnName: 'start_time', order: 'desc' },
    selectedRowData: {},
    stageOptions: [],
    filteredStage: [],
    fdfeedFilesFilter: {},
    performance: { nothing: { totalTime: 0, count: 0 } },
    performanceData: { },
    fdFeedFilesColumns:
        'uuid,original_name,batch_id,current_stage,status,feed_id,created_at,updated_at,source,json_key,file_id,upload_id',
    headers: {
        client: { name: 'Client', filter: true, style: { width: '10%' } },
        source: { name: 'Source', filter: true, style: { width: '5%' } },
        // uuid: { name: 'FeedId - UUID', filter: true, style: { width: '110px' } },
        // mccDetailIdUploadId: { name: 'Mcc Detail/Upload', filter: true, style: { width: '80px' } },
        //   batchId: { name: 'Batch Id', filter: true, style: { width: '110px' } },
        fileId: { name: 'File Id', filter: true, style: { width: '7%' } },
        filename: { name: 'File Name', filter: true, style: { width: '19%' } },
        fileCreateTime: { name: 'File Create Time', filter: true, style: { width: '13%' } },
        current_stage: { name: 'Current Stage', filter: true, style: { width: '12%' } },
        status: { name: 'Status', filter: true, style: { width: '6%' } },
        start_time: { name: 'Start Time', filter: true, style: { width: '11%' } },
        end_time: { name: 'End Time', filter: true, style: { width: '11%' } },
        failed_stages: { name: 'Failed Stages', filter: true, style: { width: '6%' } },
        isAllDone: { name: 'All Done', filter: true, style: { width: '6%' } },

    },
    isHistoryView: dashboardService.isHistoryView(),
    selectedFlow: '',
    selectedClient: '',
};

const reducers = {
    setContextMenu: (state, action) => {
        state.contextMenu = action.payload;
    },
    setStageOption: (state) => {
        const stageOptions = Object.entries(dashboardService.stages).map(
            ([value, { text }]) => ({ label: text, value }),
        );
        state.stageOptions = stageOptions;
    },
    setFilterStages: (state, action) => {
        state.filteredStage = action.payload.map((stage) => stage.value);
    },
    setFdFeedFilesFilters: (state, action) => {
        const { id, value } = action.payload;
        const filters = { ...state.fdfeedFilesFilter, [id]: value };

        // keep only filters with non-empty values
        const result = Object.entries(filters).reduce((acc, [key, val]) => {
            if (val?.length) acc[key] = val;
            return acc;
        }, {});

        state.fdfeedFilesFilter = result;
        state.currentPage = 1;
    },
    columnsChange: (state, action) => {
        Object.assign(state.columns, action.payload);
    },
    pageChange: (state, action) => {
        state.page = action.payload;
    },
    setLimit: (state, action) => {
        state.limit = action.payload;
    },
    onFilter: (state, action) => {
        state.filterData = action.payload;
    },
    limitChange: (state, action) => {
        state.limit = action.payload;
    },
    onChangeOrder: (state, action) => {
        state.sortColumn = action.payload;
    },
    onLimitChanged: (state, action) => {
        state.pageLimit = action.payload;
    },
    onPageChanged: (state, action) => {
        state.currentPage = action.payload.currentPage;
    },
    closeDataModal: (state) => {
        state.selectedRowData = {};
    },

    saveHistoryPerformance: (state, action) => {
        state.historyPerformance = action.payload;
    },
    setSelectedFlow: (state, action) => {
        state.selectedFlow = action.payload;
    },
    setSelectedClient: (state, action) => {
        state.selectedClient = action.payload;
    },

};

// Async actions
export const list = createAsyncThunk('dashboard/list', dashboardService.list);
export const showData = createAsyncThunk('dashboard/showData', dashboardService.showData);
export const remove = createAsyncThunk('dashboard/remove', dashboardService.remove);
export const retry = createAsyncThunk('dashboard/retry', dashboardService.retry);
export const reprocess = createAsyncThunk('dashboard/reprocess', dashboardService.reprocess);
export const updateData = createAsyncThunk('dashboard/updateData', dashboardService.updateData);
export const getPerformanceData = createAsyncThunk('dashboard/getPerformanceData', dashboardService.getPerformanceData);
export const getClientList = createAsyncThunk('dashboard/getClientList', dashboardService.getClientList);

const DashboardSlice = createSlice({
    name: 'dashboard',
    initialState: DashboardState,
    reducers,
    extraReducers: (builder) => {
        builder
            .addCase(list.pending, (state) => {
                state.gettingData = true;
            })
            .addCase(list.fulfilled, (state, action) => {
                state.listResponse = action.payload.listResponse;
                state.performance = action.payload.performance;
                state.historyPerformance = JSON.parse(localStorage.getItem('queue_performance_history') || '{}');
                state.isHistoryView = dashboardService.isHistoryView();
                if (state.pageLimit > action.payload.totalRecords) {
                    state.currentPage = 1;
                }

                state.totalRecords = action.payload.totalRecords;
                state.data = action.payload.data;
                state.gettingData = false;
            })
            .addCase(list.rejected, (state) => {
                state.gettingData = false;
            })
            .addCase(retry.pending, (state) => {
                state.isRetrying = true;
            })
            .addCase(retry.fulfilled, (state) => {
                state.isRetrying = false;
            })
            .addCase(retry.rejected, (state) => {
                state.isRetrying = false;
            })
            .addCase(reprocess.pending, (state) => {
                state.isReprocess = true;
            })
            .addCase(reprocess.fulfilled, (state, action) => {
                if (!action.payload.status) alert(action.payload.message);
                state.isReprocess = false;
            })
            .addCase(reprocess.rejected, (state) => {
                state.isReprocess = false;
            })
            .addCase(showData.fulfilled, (state, action) => {
                state.selectedRowData = action.payload;
            })
            .addCase(updateData.pending, (state) => {
                state.isUpdating = true;
            })
            .addCase(updateData.fulfilled, (state) => {
                state.isUpdating = false;
                state.selectedRowData = {};
            })
            .addCase(updateData.rejected, (state) => {
                state.isUpdating = false;

                state.selectedRowData = {};
            })
            .addCase(getPerformanceData.fulfilled, (state, action) => {
                state.performanceData = action.payload;
            })
            .addCase(getPerformanceData.rejected, (state) => {
                state.performanceData = {};
            })
            .addCase(getClientList.fulfilled, (state, action) => {
                console.log('XXXXXXXXXXXXXXaction.payloadXXXXXXXXXXXXX', action.payload);
                state.clients = action.payload;
            })
            .addCase(getClientList.rejected, (state) => {
                state.clients = [];
            });
    },
});

export const DashboardReducer = DashboardSlice.reducer;
export const DashboardActions = DashboardSlice.actions;

export const DashboardStore = configureStore({
    reducer: { dashboard: DashboardReducer },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
});
